import { Stack } from '@mui/material';

interface TabViewProps<T> {
  viewType: T;
  selectedView: T;
  children?: React.ReactNode;
}

export const TabView = <T,>({
  viewType,
  selectedView,
  children,
}: TabViewProps<T>) => (
  <Stack {...(viewType === selectedView ? {} : { display: 'none' })}>
    {children}
  </Stack>
);
